import { createAction } from '@reduxjs/toolkit';
const SET_YOU_FINANCE_TEXT = 'SET_YOU_FINANCE_TEXT';
const SET_PRICE_HERO_INFO = 'SET_PRICE_HERO_INFO';
const SET_PRODUCT_CARD_DATA = 'SET_PRODUCT_CARD_DATA';
const SET_PRODUCT_CARD_LABELS = 'SET_PRODUCT_CARD_LABELS';
export const SET_VIEW_360_STATE = 'SET_VIEW_360_STATE';
export const SET_IS_NOTIFY_ME_LOADED = 'SET_IS_NOTIFY_ME_LOADED';
export const SET_IS_TEST_RIDE_LINK_LOADED = 'SET_IS_TEST_RIDE_LINK_LOADED';
const SET_LINK_FOR_TEST_RIDE = 'SET_LINK_FOR_TEST_RIDE';
const SET_COMPATIBILITY_CHECK_ALLOWED = 'SET_COMPATIBILITY_CHECK_ALLOWED';
const SET_PRODUCT_SKU_LIST = 'SET_PRODUCT_SKU_LIST';
const SET_PRODUCT_QUANTITY = 'SET_PRODUCT_QUANTITY';
export const SET_CHECK_COMPATIBILITY_PRODUCT = 'SET_CHECK_COMPATIBILITY_PRODUCT';
// Types for Filter feature
export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS';
export const SET_PREV_PAGE_TYPE = 'SET_PREV_PAGE_TYPE';
export const SET_PREV_GROUPING_PRODUCT_SKU = 'SET_PREV_GROUPING_PRODUCT_SKU';
const SET_CLEAR_FILTER_OPTIONS = 'SET_CLEAR_FILTER_OPTIONS';
export const setYouFinanceText = createAction(SET_YOU_FINANCE_TEXT);
export const setPriceHeroInfo = createAction(SET_PRICE_HERO_INFO);
export const setProductCardData = createAction(SET_PRODUCT_CARD_DATA);
export const setProductCardLabels = createAction(SET_PRODUCT_CARD_LABELS);
export const setIsTestRideLinkLoaded = createAction(SET_IS_TEST_RIDE_LINK_LOADED);
export const setView360State = createAction(SET_VIEW_360_STATE);
export const setIsNotifyMeLoaded = createAction(SET_IS_NOTIFY_ME_LOADED);
export const setLinkForTestRide = createAction(SET_LINK_FOR_TEST_RIDE);
export const setPrevPageType = createAction(SET_PREV_PAGE_TYPE);
export const setPrevGroupingProductSku = createAction(SET_PREV_GROUPING_PRODUCT_SKU);
export const setCompatibilityCheckAllowed = createAction(SET_COMPATIBILITY_CHECK_ALLOWED);
export const setProductSkuList = createAction(SET_PRODUCT_SKU_LIST);
export const setSelectedCompatibilityProduct = createAction(SET_CHECK_COMPATIBILITY_PRODUCT);
export const setProductQuantity = createAction(SET_PRODUCT_QUANTITY);
// Action for Filter feature
export const setFilterOptions = createAction(SET_FILTER_OPTIONS);
export const setClearFilterOptions = createAction(SET_CLEAR_FILTER_OPTIONS);
